import { policyActionTypes as actionType } from 'src/constants/actionTypes';

const initialState = {
  list: [],
  success: '',
  error: '',
};

const policyReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionType.GET_ALL_SUCCESS: {
      const { policies } = action.payload;
      return {
        ...state,
        list: policies,
      };
    }

    case actionType.GET_SUCCESS: {
      const { policy } = action.payload;
      return {
        ...state,
        selectedPolicy: { ...state.selectedPolicy, ...policy },
      };
    }

    case actionType.GET_REPOSITORIES_SUCCESS: {
      const { repositories } = action.payload;
      return {
        ...state,
        selectedPolicy: { ...state.selectedPolicy, repositories },
      };
    }

    case actionType.GET_USERS_SUCCESS: {
      const { users } = action.payload;
      return {
        ...state,
        selectedPolicy: { ...state.selectedPolicy, users },
      };
    }

    case actionType.UPDATE_SUCCESS: {
      const { updatedPolicy, successMsg } = action.payload;

      const newList = state.list.map((p) => ((p.id === updatedPolicy.id) ? updatedPolicy : p));

      return {
        ...state,
        list: newList,
        success: successMsg,
      };
    }

    case actionType.CREATE_SUCCESS: {
      const { policy, successMsg } = action.payload;
      return {
        ...state,
        list: [...state.list, policy],
        success: successMsg,
      };
    }

    case actionType.DELETE_SUCCESS: {
      const { id, successMsg } = action.payload;
      const filteredList = state.list.filter((policy) => policy.id !== id);

      return {
        ...state,
        list: filteredList,
        success: successMsg,
      };
    }

    case actionType.FAILURE: {
      const { error } = action.payload;
      return {
        ...state,
        error
      };
    }

    case actionType.CLEAR_MESSAGES: {
      return {
        ...state,
        success: '',
        error: ''
      };
    }

    default: {
      return state;
    }
  }
};

export default policyReducer;
